function nunjucks_global_url(routing, i18n)
{
    this.name = 'url';
    this.value = function(route, params)
    {
        params = params||{};
        if (!params.lang) {
            params.lang = i18n.lang;
        }
        return routing.urlFor(route, params);
    };
}